import React, { PureComponent } from 'react';
import { Icon, Row, Col } from 'antd';
import { cloneDeep } from 'lodash';
import { LinkType, UploadPicture } from '../../tools';

export default class ShowcaseItem extends PureComponent<any> {
    state = {
        uploadLoading: false,
    };
    change = (item) => {
        const { items, index, onChange } = this.props;
        let newItems = cloneDeep(items);
        newItems.splice(index, 1, item);
        onChange(newItems);
    };

    removeItem = () => {
        const { items, onChange, index } = this.props;
        let newValue = cloneDeep(items);
        newValue.splice(index, 1, {});
        onChange(newValue);
    };
    onUpload = (path) => {
        const { item } = this.props;
        let newItem = cloneDeep(item);
        newItem.pic = path;
        this.change(newItem);
    };

    render() {
        const { item, linkTypes, linkTypeMode, uploadAction, sourceRoot, selector } = this.props;
        return (
            <Row className="entry-item">
                <Icon type="close" className="item-remove" title="移除" onClick={this.removeItem} />
                <Col className="entry-item-image" span={5}>
                    <UploadPicture
                        sourceRoot={sourceRoot}
                        value={item.pic}
                        onChange={this.onUpload}
                        uploadAction={uploadAction}
                    />
                </Col>
                <Col className="entry-item-content" span={18}>
                    <LinkType
                        selector={selector}
                        linkTypes={linkTypes}
                        linkTypeMode={linkTypeMode}
                        value={item}
                        onChange={this.change}
                    />
                </Col>
            </Row>
        );
    }
}
